import React, { Component } from "react";
import {
  Form,
  FormField,
  TextBox,
  DateBox,
  ComboBox,
  Panel,
  LinkButton,
  Messager,
} from "rc-easyui";
import { getAccessToken, getCookie } from "../../../helpers/cookieHelper";
import { Button } from "reactstrap";
import { API_URL } from "../../../constants";
import { isEmpty, getFormattedDate } from "../../../helpers";
const axios = require("axios");
class AddNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      Clients: [],
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(name, value) {
    this.props.handleChange(name, value);
  }

  async handleSave() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.formFields);

    let apiUrl = `${API_URL}api/publishnotice`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    form["startDate"] = getFormattedDate(form["startDate"]);
    form["endDate"] = getFormattedDate(form["endDate"]);

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          axios
            .post(apiUrl, form, headersConfig)
            .then((response) => {
              //console.log("response", response);
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan  Saved Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
                // this.props.formClear();
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleSave();
          }
        }
      } else {
        //console.log("Front End Form Validaion ");
      }
    });
  }

  handleUpdate() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.props.formFields);

    let apiUrl = `${API_URL}api/publishnotice/${form.id}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    form["startDate"] = getFormattedDate(form["startDate"]);
    form["endDate"] = getFormattedDate(form["endDate"]);

    this.props.innerRef.current.validate(async (errors) => {
      if (isEmpty(errors)) {
        //No Form Validation Error
        if (token != null) {
          //Access Token Available
          this.setState({
            isLoading: true,
          });
          //console.log(form);
          axios
            .put(apiUrl, form, headersConfig)
            .then((response) => {
              if (response.status === 200) {
                this.setState({
                  isLoading: false,
                });
                if (response.data.status) {
                  this.messager.alert({
                    title: "Success",
                    msg: response.data.message,
                    reload: true,
                  }); // Price Plan Updated Successfully ie. 200
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: response.data.message,
                  });
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Uncaught Error",
                  reload: false,
                });
              }
            })
            .catch((error) => {
              this.setState({
                isLoading: false,
              });
              this.messager.alert({
                title: "Error",
                msg: "Internal Server Error",
                reload: false,
              });
              var response = error["response"];
              if (response !== undefined) {
                if (response.status === 400) {
                  var message = "";
                  response.data.errors.forEach((row, i) => {
                    message +=
                      "<p style='margin-bottom:3px;'>" +
                      row.defaultMessage +
                      "</p>";
                  });
                  //console.log(message);
                  this.messager.alert({
                    title: "Error",
                    msg: message,
                    reload: false,
                  }); // Backend Validation Error ie.400
                } else {
                  this.messager.alert({
                    title: "Error",
                    msg: "UnCaught Error",
                    reload: false,
                  }); // Uncaught Backend Error ie.500 eyc.
                }
              } else {
                this.messager.alert({
                  title: "Error",
                  msg: "Internal Server Error",
                  reload: false,
                }); // Caused due to syntax error in front end
              }
            });
        } else {
          //Access Token Expired.
          //Generate new Access Token using Refresh Token.
          const resp = await getAccessToken();
          if (resp) {
            this.handleUpdate();
          }
        }
      } else {
        alert("Front End Form Validaion ");
      }
    });
  }

  render() {
    const form = this.props.formFields;
    const rules = this.props.validationRules;
    const operation = this.props.operation;
    const isLoading = this.state.isLoading;

    return (
      <div>
        <Panel title='Publish Notice' bodyStyle={{ padding: 20 }}>
          <Messager
            ref={(ref) => (this.messager = ref)}
            showHeader={false}
            borderType='none'
            content={({ title, msg, buttons, reload }) => (
              <div className='alert-content'>
                <h3>{title}</h3>
                <div
                  style={{ marginBottom: 5 }}
                  dangerouslySetInnerHTML={{ __html: msg }}
                ></div>
                <div className='m-buttons'>
                  {buttons.map((button, index) => (
                    <LinkButton
                      key={index}
                      text={button.text}
                      onClick={() => {
                        this.messager.close(button);
                        if (reload) {
                          window.location.reload();
                        }
                      }}
                    />
                  ))}
                </div>
              </div>
            )}
          />
          <div
            className='loadingmodel'
            style={{ display: isLoading ? "block" : "none" }}
          ></div>
          <Form
            ref={this.props.innerRef}
            model={form}
            labelWidth={400}
            labelAlign='left'
            rules={rules}
            // validateRules={this.customValidations()}
            labelPosition='top'
            onChange={this.handleChange.bind(this)}
          >
            <FormField name='clientId' label='Clients:'>
              <ComboBox
                style={{ width: "100%" }}
                data={this.props.clients}
                value={form.clientId}
                valueField='clientid'
                textField='organizationname'
              ></ComboBox>
            </FormField>
            <FormField name='noticeBody' label='Notice:'>
              <TextBox
                inputId='t2'
                multiline
                value={form.noticeBody}
                style={{ width: "100%", height: 120 }}
              ></TextBox>
            </FormField>
            <FormField name='displayArea' label='Display Area:'>
              <ComboBox
                style={{ width: "100%" }}
                data={[
                  { value: "login", text: "Login" },
                  { value: "dashboard", text: "Dashboard" },
                  { value: "both", text: "Both" },
                ]}
                value={form.displayArea}
              ></ComboBox>
            </FormField>
            <FormField name='startDate' label='Start Date:'>
              <DateBox
                inputId='startDate'
                format='yyyy-MM-dd'
                value={form.startDate}
                calendarOptions={{
                  validator: (date) => {
                    if (this.props.operation === "ADD") {
                      var now = new Date();
                      var d1 = new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate()
                      );

                      return d1 <= date;
                    } else {
                      return true;
                    }
                  },
                }}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </FormField>
            <FormField name='endDate' label='End Date:'>
              <DateBox
                inputId='d2'
                format='yyyy-MM-dd'
                value={form.endDate}
                calendarOptions={{
                  validator: (date) => {
                    var now = new Date();
                    var d1 = new Date(
                      now.getFullYear(),
                      now.getMonth(),
                      now.getDate()
                    );

                    return d1 <= date;
                  },
                }}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </FormField>

            <FormField name='enabled' label='Status:'>
              <ComboBox
                data={[
                  { value: true, text: "Active" },
                  { value: false, text: "Inactive" },
                ]}
                editable={false}
                valueField='value'
                textField='text'
                value={form.enabled}
                style={{ width: "100%" }}
              ></ComboBox>
            </FormField>
          </Form>
          <hr />
          <div className='text-center'>
            <Button
              color='primary'
              onClick={
                operation === "Add" ? this.handleSave : this.handleUpdate
              }
              disabled={isLoading ? true : false}
              style={{ marginRight: 20 }}
            >
              {operation === "Add" ? "Save" : "Update"}
            </Button>
            <Button color='danger' onClick={this.props.formClear}>
              Cancel
            </Button>
          </div>
        </Panel>
      </div>
    );
  }
}
export default React.forwardRef((props, ref) => (
  <AddNotice innerRef={ref} {...props} />
));
